import React from 'react'
import TableBureau from '../../../Components/table/TableBureau'

const Bureaux = () => {
  return <TableBureau />
}

export default Bureaux
